import { useEffect } from 'react';

function useChangeValue<T>(value: T, setValue: (value: T) => void) {
  useEffect(() => {
    setValue(value);
  }, [JSON.stringify(value)]);
}

export default useChangeValue;
